import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Blog } from 'src/app/models/article';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ArticleService {

  baseUrl = environment.baseURL+'api/blog';
  constructor(private http:HttpClient) { }

  getAllArticles(): Observable<Blog[]>{
    return this.http.get<Blog[]>(`${this.baseUrl}s`)
  }

  getArticleDetails(id:string): Observable<Blog>{
    return this.http.get<Blog>(`${this.baseUrl}/${id}`)
  }
}
